
import { FSharpRef, Record, Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { generate, svgPath, viewBoxSize, QrMatrix_$reflection } from "../QrCode.js";
import { record_type, obj_type, lambda_type, unit_type, union_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { Fragment, useEffect, useRef, useState, createElement } from "react";
import React from "react";
import { disposeSafe, int32ToString, createObj } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { iterate as iterate_1, empty, ofArray, toArray, singleton, append } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { iterate, empty as empty_1, append as append_1, singleton as singleton_1, collect, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { textColor_textPrimary700, borderColor_borderPrimary600, textColor_textNeutral700, textColor_textDanger700, textColor_textNeutral600, lineClamp_lineClamp2, padding_pr16, md, backgroundColor_bgSurface, maxHeight_maxHNone, textColor_textNeutral900, backgroundColor_bgNeutral400, dark, backgroundColor_bgNeutral200, borderRadius_roundedFull, FocusVisible_ring, textColor_textNeutral100, backgroundColor_bgNeutral800, minHeight_minH12, tw } from "../TailwindExtensions.js";
import { padding_p2, display_inlineFlex, flexShrink_flexShrink0, display_inlineBlock, backgroundColor_bgWhite, fontSize_textSm, fontSize_textXl, padding_p4, gap_gap$002D4, flexDirection_flexCol, position_relative, height_hFit, padding_p0, position_inset0, position_fixed$0027, height_h12, width_w12, position_absolute, fontWeight_fontSemibold, fontSize_textBase, borderRadius_roundedLg, gap_gap$002D2, justifyContent_justifyCenter, alignItems_itemsCenter, display_flex, height_hFull, width_wFull } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { refSetter, useReturnFocusOnClose, useShowModal } from "../ModalDialog.js";
import { toArray as toArray_1 } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { close, currentVisibilityState, wantsReacquire, lockArrived, browserRequest, tryAcquire, release, openHold } from "../ScreenWakeLock.js";
import { payload } from "../Challenge/ChallengeShare.js";
import { isDesktopViewport, currentOrigin } from "./ShareActions.js";
import { captureException } from "../ErrorReporting.js";

export class Content extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ready", "Failed"];
    }
}

export function Content_$reflection() {
    return union_type("Shared.QrCodeButton.Content", [], Content, () => [[["Item", QrMatrix_$reflection()]], []]);
}

export const buttonLabel = "Show QR code";

export const failureMessage = "Couldn\'t make a QR code. Share the link instead.";

class Handlers extends Record {
    constructor(Open, Close, CloseIfBackdrop, TriggerRef, DialogRef) {
        super();
        this.Open = Open;
        this.Close = Close;
        this.CloseIfBackdrop = CloseIfBackdrop;
        this.TriggerRef = TriggerRef;
        this.DialogRef = DialogRef;
    }
}

function Handlers_$reflection() {
    return record_type("Shared.QrCodeButton.Handlers", [], Handlers, () => [["Open", lambda_type(unit_type, unit_type)], ["Close", lambda_type(unit_type, unit_type)], ["CloseIfBackdrop", lambda_type(unit_type, unit_type)], ["TriggerRef", lambda_type(obj_type, unit_type)], ["DialogRef", lambda_type(obj_type, unit_type)]]);
}

const noHandlers = new Handlers(() => {
}, () => {
}, () => {
}, (value_3) => {
}, (value_4) => {
});

function elementId(ch) {
    return `qr-${ch.Id}`;
}

/**
 * React key for the stateful button: when the displayed challenge changes (SPA back/forward),
 * the button remounts so its open dialog and captured URL are discarded.
 */
export function instanceKey(ch) {
    return elementId(ch);
}

function svgElement(tag, attributes, children) {
    return createElement(tag, createObj(append(singleton(["key", tag]), append(toList(delay(() => collect((matchValue) => {
        let name;
        return singleton_1([(name = matchValue[0], (name === "class") ? "className" : ((name === "shape-rendering") ? "shapeRendering" : name)), matchValue[1]]);
    }, attributes))), singleton(["children", toArray(children)])))));
}

function qrImage(url, m) {
    const side = int32ToString(viewBoxSize(m));
    return svgElement("svg", ofArray([["role", "img"], ["aria-label", concat("QR code for ", url)], ["viewBox", concat("0 0 ", side, " ", side)], ["shape-rendering", "crispEdges"], ["class", tw(ofArray(["block", width_wFull, height_hFull]))]]), ofArray([svgElement("rect", ofArray([["width", side], ["height", side], ["fill", "#fff"]]), empty()), svgElement("path", ofArray([["d", svgPath(m)], ["fill", "#000"]]), empty())]));
}

const closeButtonClass = tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, width_wFull, minHeight_minH12, borderRadius_roundedLg, backgroundColor_bgNeutral800, textColor_textNeutral100, fontSize_textBase, fontWeight_fontSemibold, FocusVisible_ring]));

export const closeIconButtonClass = tw(ofArray([position_absolute, "top-4", "right-4", display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, width_w12, height_h12, borderRadius_roundedFull, backgroundColor_bgNeutral200, dark(backgroundColor_bgNeutral400), textColor_textNeutral900, FocusVisible_ring]));

const shortLandscapeCodeCell = tw(ofArray(["short-landscape:col-start-1", "short-landscape:row-span-full", "short-landscape:self-center"]));

function dialog(id, ch, url, content, h) {
    const titleId = id + "-title";
    return HtmlHelper_createElement("dialog", ofArray([["ref", (el) => {
        h.DialogRef(el);
    }], ["aria-labelledby", join(" ", [titleId])], ["tabIndex", -1], ["className", tw(ofArray([position_fixed$0027, position_inset0, "m-0", width_wFull, "max-w-none", "h-[100dvh]", maxHeight_maxHNone, padding_p0, backgroundColor_bgSurface, "overflow-y-auto", "md:m-auto", md(height_hFit), "md:max-w-md", "md:short-landscape:max-w-2xl", "md:max-h-[calc(100dvh-2rem)]", "md:rounded-2xl", "md:bg-surface-elevated", "md:shadow-xl", "backdrop:bg-black/50"]))], ["onCancel", (e) => {
        e.preventDefault();
        h.Close();
    }], ["onClick", (e_1) => {
        if (e_1.target === e_1.currentTarget) {
            h.CloseIfBackdrop();
        }
    }], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_relative, display_flex, flexDirection_flexCol, justifyContent_justifyCenter, gap_gap$002D4, "min-h-full", padding_p4, "md:p-6", "short-landscape:grid", "short-landscape:grid-cols-[auto_minmax(0,1fr)]", "short-landscape:grid-rows-[1fr_auto_auto_auto_1fr]"]))], ["children", toList(delay(() => append_1(singleton_1(HtmlHelper_createElement("button", ofArray([["type", "button"], ["aria-label", "Close"], ["className", closeIconButtonClass], ["onClick", (_arg) => {
        h.Close();
    }], ["children", [createElement(icon, {
        name: new IconName(36, []),
        size: new IconSize(2, []),
        weight: new IconWeight(0, []),
    })]]]))), delay(() => append_1(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([padding_pr16, "short-landscape:col-start-2", "short-landscape:row-start-2"]))], ["children", [HtmlHelper_createElement("h2", ofArray([["id", titleId], ["className", tw(ofArray([lineClamp_lineClamp2, fontSize_textXl, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton(ch.Title)]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600]))], ["children", singleton("Scan to open this challenge")]]))]]]))), delay(() => {
        let matchValue;
        return append_1((matchValue = content, (matchValue.tag === 1) ? singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger700, shortLandscapeCodeCell]))], ["children", singleton(failureMessage)]]))) : singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundColor_bgWhite, "mx-auto", "aspect-square", "w-[min(calc(100vw-2rem),calc(100dvh-18rem))]", "short-landscape:w-[min(calc(100dvh-2rem),calc(50vw-1.5rem))]", "md:w-80", "md:short-landscape:w-[min(calc(100dvh-5rem),20rem)]", shortLandscapeCodeCell]))], ["children", [qrImage(url, matchValue.fields[0])]]])))), delay(() => append_1(singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray(["break-all", "select-text", fontSize_textSm, textColor_textNeutral700, "short-landscape:col-start-2", "short-landscape:row-start-3"]))], ["children", singleton(url)]]))), delay(() => singleton_1(HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", tw(ofArray([closeButtonClass, "short-landscape:col-start-2", "short-landscape:row-start-4"]))], ["onClick", (_arg_1) => {
            h.Close();
        }], ["children", [createElement(icon, {
            name: new IconName(36, []),
            size: new IconSize(1, []),
            weight: new IconWeight(0, []),
        }), "Close"]]])))))));
    }))))))]]))]]]));
}

function render(id, ch, state, h) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_relative, display_inlineBlock, flexShrink_flexShrink0]))], ["children", toList(delay(() => append_1(singleton_1(HtmlHelper_createElement("button", ofArray([["ref", (el) => {
        h.TriggerRef(el);
    }], ["id", id], ["type", "button"], ["aria-label", buttonLabel], ["title", buttonLabel], ["aria-haspopup", "dialog"], ["aria-expanded", (state != null) ? "true" : "false"], ["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, justifyContent_justifyCenter, flexShrink_flexShrink0, borderRadius_roundedLg, "border-2", borderColor_borderPrimary600, textColor_textPrimary700, padding_p2, FocusVisible_ring]))], ["onClick", (_arg) => {
        h.Open();
    }], ["children", [createElement(icon, {
        name: new IconName(69, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    })]]]))), delay(() => {
        const matchValue = state;
        if (matchValue == null) {
            return empty_1();
        }
        else {
            return singleton_1(dialog(id, ch, matchValue[0], matchValue[1], h));
        }
    }))))]]));
}

/**
 * Renders any state with inert handlers.
 */
export function renderState(ch, state) {
    return render(elementId(ch), ch, state, noHandlers);
}

function QrCodeButtonComponent($props) {
    const ch = $props.ch;
    const patternInput = useState(undefined);
    const state = patternInput[0];
    const setState = patternInput[1];
    const triggerRef = useRef(undefined);
    const dialogRef = useRef(undefined);
    useShowModal(dialogRef, state);
    useReturnFocusOnClose(triggerRef, state != null);
    const dependencies = [state != null];
    useEffect(() => {
        const setup = (() => {
        let disp;
        if (state != null) {
            iterate((d) => {
                d.focus();
            }, toArray_1(dialogRef.current));
        }
        disp = {
            Dispose() {
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    const dependencies_2 = [state != null];
    useEffect(() => {
        const setup = (() => {
        let disp_1;
        const hold = new FSharpRef(openHold());
        const applyTransition = (tupledArg) => {
            hold.contents = tupledArg[0];
            iterate_1((sentinel) => {
                release(sentinel);
            }, tupledArg[1]);
        };
        const acquire = () => {
            const pr = tryAcquire(browserRequest());
            void (pr.then((outcome) => {
                switch (outcome.tag) {
                    case 1:
                    case 2: {
                        break;
                    }
                    default:
                        applyTransition(lockArrived(outcome.fields[0], hold.contents));
                }
            }));
        };
        const onVisibilityChange = (_arg) => {
            if (wantsReacquire(hold.contents, currentVisibilityState())) {
                acquire();
            }
        };
        if (state != null) {
            acquire();
            document.addEventListener("visibilitychange", onVisibilityChange);
        }
        disp_1 = {
            Dispose() {
                document.removeEventListener("visibilitychange", onVisibilityChange);
                applyTransition(close(hold.contents));
            },
        };
        return () => {
            let copyOfStruct_1 = disp_1;
            disposeSafe(copyOfStruct_1);
        };
    })();
        return setup;
        }, dependencies_2);;
    const handlers = new Handlers(() => {
        let matchValue_1;
        const matchValue = payload(currentOrigin(), ch);
        if (matchValue != null) {
            const p = matchValue;
            setState([p.Url, (matchValue_1 = generate(p.Url), (matchValue_1.tag === 1) ? ((captureException(matchValue_1.fields[0]), new Content(1, []))) : (new Content(0, [matchValue_1.fields[0]])))]);
        }
    }, () => {
        setState(undefined);
    }, () => {
        if (isDesktopViewport()) {
            setState(undefined);
        }
    }, (el) => {
        refSetter(triggerRef, el);
    }, (el_1) => {
        refSetter(dialogRef, el_1);
    });
    return render(elementId(ch), ch, state, handlers);
}

/**
 * QR trigger plus its dialog. The code is generated on click on the client, never during render.
 */
export function view(ch) {
    return createElement(Fragment, {
        key: instanceKey(ch),
    }, createElement(QrCodeButtonComponent, {
        ch: ch,
    }));
}

//# sourceMappingURL=QrCodeButton.js.map
